export const TABS = [
  { label: '十年國債', value: 'FX10YY' },
  { label: '利率指標', value: 'FXINT' },
  { label: '國際商品', value: 'FXCOM' },
  { label: '期貨外匯', value: 'FXFUT' }
];
